import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { Reveal } from "@/components/layout/Shell";

export const PromotionCarousel = ({ promotions = [] }) => {
  const [i, setI] = useState(0);
  const count = promotions.length;

  useEffect(() => {
    if (!count) return;
    const t = setInterval(() => setI(s => (s + 1) % count), 6000);
    return () => clearInterval(t);
  }, [count]);

  if (!count) return null;
  const p = promotions[i];

  return (
    <section className="promo-band" data-testid="sponsor-promotion-band">
      <Reveal className="container promo-in">
        <div className="promo-panel">
          <div className="promo-media">
            <AnimatePresence mode="sync">
              <motion.img
                key={p.id || i}
                src={p.banner}
                alt={p.company}
                data-testid={`promo-banner-${i}`}
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                exit={{ opacity: 0, position: "absolute", inset: 0 }}
                transition={{ duration: 0.8 }}
              />
            </AnimatePresence>
          </div>
          <div className="promo-copy">
            <AnimatePresence mode="wait">
              <motion.div
                key={p.id || i}
                initial={{ opacity: 0, y: 18 }}
                animate={{ opacity: 1, y: 0 }}
                exit={{ opacity: 0 }}
                transition={{ duration: 0.5 }}
                style={{ display: "grid", gap: 16 }}
              >
                <span className="badge"><i />Sponsor spotlight · {p.company}</span>
                <h2>{p.headline}</h2>
                <p>{p.description}</p>
                <div className="promo-actions">
                  {p.website && (
                    <a href={p.website} target={p.open_in_new_tab === false ? "_self" : "_blank"} rel="noreferrer" className="button button-gold" data-testid={`promo-visit-${i}`}>
                      Visit {p.company} <ArrowRight size={15} />
                    </a>
                  )}
                  <Link to="/sponsors" className="text-link light" data-testid={`promo-all-${i}`}>All sponsors <ArrowRight size={14} /></Link>
                </div>
              </motion.div>
            </AnimatePresence>
          </div>
          <div className="promo-dots" role="tablist">
            {promotions.map((_, k) => (
              <button key={k} className={k === i ? "active" : ""} onClick={() => setI(k)} aria-label={`Show promotion ${k + 1}`} data-testid={`promo-dot-${k}`} />
            ))}
          </div>
        </div>
      </Reveal>
    </section>
  );
};
